import {ConfigProvider, Form, Segmented, Select, Spin, Tag} from 'antd';
import {SmileOutlined, IdcardOutlined, UserOutlined} from '@ant-design/icons';
import {StudentsConnection} from '../../../graphql/API';

interface StudentSelectProps {
  students: StudentsConnection | undefined;
  isLoading: boolean;
  searchBy: 'NAME' | 'ID';
  onSearchByChange: (val: 'NAME' | 'ID') => void;
  onSearch: (val: string) => void;
  onScroll: (e: any) => void;
  onChange: (val: any) => void;
}

export const StudentSelect = ({
  students,
  isLoading,
  searchBy,
  onSearchByChange,
  onSearch,
  onScroll,
  onChange,
}: StudentSelectProps) => {
  return (
    <div>
      <div style={{marginBottom: 8}}>
        <Segmented
          value={searchBy}
          onChange={val => onSearchByChange(val as 'NAME' | 'ID')}
          options={[
            {label: 'Search by Name', value: 'NAME', icon: <UserOutlined />},
            {label: 'Search by ID', value: 'ID', icon: <IdcardOutlined />},
          ]}
        />
      </div>
      <ConfigProvider
        renderEmpty={() => (
          <div style={{textAlign: 'center', padding: '12px 0'}}>
            {isLoading ? (
              <Spin size="large" />
            ) : (
              <>
                <SmileOutlined style={{fontSize: 20}} />
                <p style={{marginTop: 8, color: '#999'}}>No students found</p>
              </>
            )}
          </div>
        )}>
        <Form.Item
          name="studentId"
          rules={[{required: true, message: 'Please select a student'}]}
          style={{margin: 0}}>
          <Select
            labelInValue={false}
            filterOption={false}
            showSearch
            onSearch={onSearch}
            style={{width: '100%'}}
            placeholder="Search and select a student..."
            onPopupScroll={onScroll}
            loading={isLoading}
            notFoundContent={isLoading ? <Spin size="small" /> : null}
            onChange={val => {
              onChange(val);
            }}
            optionLabelProp="label">
            {students?.items?.map(std => {
              const id = (std as any)._id || std.id;
              return (
                <Select.Option value={id} key={id} label={std.name}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                    <span>{std.name}</span>
                    <Tag
                      color="default"
                      style={{fontSize: 10, marginLeft: 8, opacity: 0.6}}>
                      {id?.slice(-6)}
                    </Tag>
                  </div>
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </ConfigProvider>
    </div>
  );
};
